// extracted by mini-css-extract-plugin
module.exports = {"container":"SportPlaceholder_container__2uO7M","loaderContainer":"SportPlaceholder_loaderContainer__NLNbG"};